import { Shopify } from "@models/shopify.model";
import { getNodes } from "@utils/getNodes";
import { MutableLineItemLookup, UnfulfilledItemsProps } from "./UnfulfilledItems.model";

const UnfulfilledItems = ({ items, fulfillments }: UnfulfilledItemsProps) => {
  const lineItems = getNodes<Shopify.OrderLineItem>(items);
  // Mutable fulfilledItems
  const fulfilledItems: MutableLineItemLookup = fulfillments.reduce(
    (_fulfilledItems, fulfillment) => {
      const items = getNodes<Shopify.FulfillmentItem>(fulfillment.fulfillmentLineItems);
      items.forEach((item: Shopify.FulfillmentItem) => {
        _fulfilledItems[item.lineItem?.variant?.id] = {
          ...item.lineItem,
          quantity: item.quantity,
        };
      });

      return _fulfilledItems;
    },
    {}
  );
  // Mutable unfulfilledItems
  const unfulfilledItems: Array<Shopify.OrderLineItem> = lineItems.reduce(
    (_unfulfilledItems, lineItem) => {
      const fulfilledMatch = fulfilledItems[lineItem?.variant?.id];

      if (!fulfilledMatch) {
        /**
         * LineItem has not been partially or entirely fulfilled.
         */
        _unfulfilledItems.push(lineItem);
        return _unfulfilledItems;
      }
      /**
       * Reduce the quantity of this line item by the
       * quantity in the fulfilled match.
       *
       * If the quantity after this operation is 0,
       * then the line item has been completely fulfilled.
       */
      const quantityFulfilled = fulfilledMatch.quantity;
      if (lineItem.quantity - quantityFulfilled > 0) {
        _unfulfilledItems.push({
          ...lineItem,
          quantity: lineItem.quantity - quantityFulfilled,
        });
      }
      return _unfulfilledItems;
    },
    []
  );

  return (
    <>
      {unfulfilledItems.map(
        (item, idx) =>
          // TO DO: MIR-1019: Update conditional when custom order attributes are added.
          (item.discountedTotalPrice?.amount !== "0.0" ||
            item.variant?.product?.tags?.includes("membership")) && (
            <li key={idx}>
              <p>
                {item.quantity > 1 && `${item.quantity} `}
                {item.title}
              </p>
            </li>
          )
      )}
    </>
  );
};

export default UnfulfilledItems;
